import React from "react";
import { Helmet } from "react-helmet";
import { Banner } from "../components/ActoLoan/Banner";
import { About } from "../components/ActoLoan/About";
import { Services_New } from "../components/ActoLoan/Services_New";
import { Features_New } from "../components/ActoLoan/Features_New";
import { Process_New } from "../components/ActoLoan/Process_New";
import { Advantages_V3 } from "../components/ActoLoan/Advantages_V3";
import { HomeCalculator } from "../components/ActoLoan/HomeCalculator";
import { Stats_New } from "../components/ActoLoan/Stats_New";
import { Trust_Stream } from "../components/ActoLoan/Trust_Stream";
import { GetStarted_New } from "../components/ActoLoan/GetStarted_New";
import { FAQHome } from "../components/ActoLoan/FAQHome";
import ChatButton from "../components/ChatButton";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Apply for instant personal loan | ActoLoan</title>
        <meta name="title" content="Apply for instant personal loan | ActoLoan" />
        <meta name="description" content="ActoLoan provides easy personal loan without any collateral and hidden charges with instant credit in your account. Apply now for personal loan and get quick funds." />
      </Helmet>
      <div className="page_wrapper">
        <div className="container">
          <Banner />
        </div>
        <Process_New />
        {/* Forces hot reload */}
        <About />
        <Services_New />
        <Features_New />

        {/* <Advantages_V3 /> */}
        <HomeCalculator />
      </div>
      <Stats_New />
      <Trust_Stream />
      <GetStarted_New />
      <FAQHome />
      <ChatButton />
    </>
  );
};

export default Home;